import { render } from "./UserBaseForm.vue?vue&type=template&id=2c739071&scoped=true"
import script from "./UserBaseForm.vue?vue&type=script&lang=js"
export * from "./UserBaseForm.vue?vue&type=script&lang=js"

import "./UserBaseForm.vue?vue&type=style&index=0&id=2c739071&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c739071"]])

export default __exports__